import React, { useMemo } from "react";
import { Button, Input } from "reactstrap";
import ReactTable from "react-table";
import { Card, CardBody } from "reactstrap";
import { displayDefaultDateFormater, mustBeArray } from "../../utils/lib";
import TankSwapDisclaimer from "../Common/TankSwapDisclaimer";

const TankSwapList = ({
  handleSelection,
  tanks,
  selectedTank,
  handleTermsAgreementChange, 
  conditionAgreed, 
  expectedVolumeMet,
  tanksLoading
}) => {
  const getButtonClassName = (id) => {
    if (selectedTank && selectedTank !== id) return "bg-faded";
    return "bg-primary";
  };

  const getLocationName = () => {
    const location = mustBeArray(tanks).find((o) => o.tankId === selectedTank);
    return location && location.locationName;
  };

  const getColumns = () => {
    return [
      {
        id: "location",
        Header: "Location",
        accessor: (x) => x.locationName,
      },
      {
        id: "tank",
        Header: "Tank Size and Type",
        accessor: (x) => x.tankName,
        Cell: (row) => (
          <div className="flex justify-content-center ">
            {row.original.tankName}
          </div>
        ),
      },
      {
        id: "date",
        Header: "Installation Date",
        accessor: (x) => x.installationDate,
        maxWidth: 200,
        Cell: (row) => (
          <div className="flex justify-content-center ">
            {displayDefaultDateFormater({
              value: row.original.installationDate,
            })}
          </div>
        ),
      },
      {
        id: "requestUrgent",
        accessor: (x) => x.selected,
        Header: "Request Urgent",
        maxWidth: 160,
        sortable: false,
        Cell: (row) => (
          <div className="flex justify-content-center">
            <Button
              className={`btn ${getButtonClassName(row.original.tankId)}`}
              onClick={() => handleSelection(row.original.tankId)}
            >
              Service Request
            </Button>
          </div>
        ),
      },
    ];
  };

  const isVacuum = useMemo(() => {
    const tank = mustBeArray(tanks).find(o => o.tankId === selectedTank);
    return tank && tank.isVacuum;
  },[selectedTank, tanks]);
  return (
    <React.Fragment>
      <Card className="p-1">
        <CardBody>
          <ReactTable
            sortable
            filterable={false}
            showPagination={true}
            defaultPageSize={20}
            data={mustBeArray(tanks)}
            columns={getColumns()}
            minRows={
              mustBeArray(tanks).length === 0
                ? 5
                : mustBeArray(tanks).length > 20
                ? 20
                : mustBeArray(tanks).length
            }
            className="selectableRowTable br-1"
            loading={tanksLoading}
          />
        </CardBody>
      </Card>
      {selectedTank && (
        <Card className="p-1">
          <h5>{`${getLocationName()} - Tank repair/replacement disclaimer`}</h5>
          <CardBody>
            <React.Fragment>
              <TankSwapDisclaimer expectedVolumeMet={expectedVolumeMet} />
              <div className={"ml-2 mt-h flex align-items-center"}>
                <Input
                  type="checkbox"
                  className="mr-q mb-q"
                  onChange={(e) => handleTermsAgreementChange(e)}
                  checked={conditionAgreed}
                />{" "}
                Yes I accept
              </div>
            </React.Fragment>
          </CardBody>
        </Card>
      )}
    </React.Fragment>
  );
};
export default TankSwapList;
